import * as actionTypes from '../types/savedProducts';

const initialState = {
  inputPieces: [],
  zdvlByTask: [],
  zdvlLineNumIdsByTask: [],
  readyProductsBySemi: [],
  plantOperationAttribsInheritDtos: [],
  zdvlByTaskGet: {
    okRequest: false,
    loading: false
  },
  length: 0,
  mark: '' || null,
  normativeDoc: '' || null,
  operationNumId: 0 || null,
  operationType: 0 || null,
  pieceId: '' || null,
  pieceNumId: 0 || null,
  profileSize: '' || null,
  qcDate: '' || null,
  qcId: 0 || null,
  qty: 0 || null,
  thickness: 0 || null,
  quantity: 0,
  quantityOff: 0,
  zdvlLineId: 0 || null,
  zdvlLineNumId: 0 || null,
  capacityPipe: 0 || null,
  capacityAvailable: 0 || null,
  productUnit: '' || null,
  error: false,
  loading: false,
  okRequest: false,
  okSaveRequest: false,
  okRequestModal: false,
  loadingModal: false,
  saved: false,
  saving: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.LOAD_READY_PRODUCTS:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.LOAD_READY_PRODUCTS_SUCCESS:
      return {
        ...state,
        length: payload.length,
        mark: payload.mark,
        normativeDoc: payload.normativeDoc,
        operationNumId: payload.operationNumId,
        operationType: payload.operationType,
        pieceId: payload.pieceId,
        pieceNumId: payload.pieceNumId,
        profileSize: payload.profileSize,
        qcDate: payload.qcDate,
        qcId: payload.qcId,
        qty: payload.qty,
        thickness: payload.thickness,
        quantity: payload.quantity,
        quantityOff: payload.quantityOff,
        zdvlLineId: payload.zdvlLineId,
        zdvlLineNumId: payload.zdvlLineNumId,
        inputPieces: payload.inputPieces,
        plantOperationAttribsInheritDtos: payload.plantOperationAttribsInheritDtos,
        loading: false,
        saving: false,
        okRequest: true
      };
    case actionTypes.SET_READY_PRODUCTS_PIECES: {
      return {
        ...state,
        inputPieces: payload
      };
    }
    case actionTypes.SAVE_READY_PRODUCTS:
      return {
        ...state,
        okSaveRequest: false,
        loading: true,
        saving: true
      };
    case actionTypes.SAVE_READY_PRODUCTS_SUCCESS:
      return {
        ...state,
        okSaveRequest: true,
        loading: false,
        saving: false
      };
    case actionTypes.SAVE_READY_PRODUCTS_FAIL:
      return {
        ...state,
        okSaveRequest: false,
        loading: false,
        saving: false
      };
    case actionTypes.GET_SAVED_PRODUCTS:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.GET_SAVED_PRODUCTS_SUCCESS:
      return {
        ...state,
        length: payload.length,
        mark: payload.mark,
        normativeDoc: payload.normativeDoc,
        operationNumId: payload.operationNumId,
        operationType: payload.operationType,
        pieceId: payload.pieceId,
        pieceNumId: payload.pieceNumId,
        profileSize: payload.profileSize,
        qcDate: payload.qcDate,
        qcId: payload.qcId,
        qty: payload.qty,
        thickness: payload.thickness,
        quantity: payload.quantity,
        zdvlLineId: payload.zdvlLineId,
        inputPieces: payload.inputPieces,
        zdvlLineNumId: payload.zdvlLineNumId,
        quantityOff: payload.quantityOff,
        loading: false,
        saved: true
      };
    case actionTypes.GET_SAVED_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false,
        saved: false
      };
    case actionTypes.SET_SAVED_RESPONSE:
      return {
        ...state,
        saveResponse: payload
      };
    case actionTypes.GET_READY_PRODUCTS_SUCCESS:
      return {
        ...state,
        readyProducts: payload,
        loading: false
      };
    case actionTypes.GET_READY_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.GET_READY_PRODUCTS_CLEAR:
      return {
        ...state,
        error: false,
        loading: false,
        okRequest: false,
        okRequestModal: false,
        loadingModal: false
      };
    case actionTypes.SET_NORMATIVE_DOC:
      return {
        ...state,
        normativeDoc: payload
      };
    case actionTypes.SET_MARK:
      return {
        ...state,
        mark: payload
      };
    case actionTypes.SET_LENGTH:
      return {
        ...state,
        length: payload
      };
    case actionTypes.SET_OPERATION_NUM_ID:
      return {
        ...state,
        operationNumId: payload
      };
    case actionTypes.SET_OPERATION_TYPE:
      return {
        ...state,
        operationType: payload
      };
    case actionTypes.SET_PROFILE_SIZE:
      return {
        ...state,
        profileSize: payload
      };
    case actionTypes.SET_PIECE_ID:
      return {
        ...state,
        pieceId: payload
      };
    case actionTypes.SET_PIECE_NUM_ID:
      return {
        ...state,
        pieceNumId: payload
      };
    case actionTypes.SET_ZDVL_LINE_ID:
      return {
        ...state,
        zdvlLineId: payload
      };
    case actionTypes.SET_ZDVL_LINE_NUM_ID:
      return {
        ...state,
        zdvlLineNumId: payload
      };
    case actionTypes.SET_QC_DATE:
      return {
        ...state,
        qcDate: payload
      };
    case actionTypes.SET_QC_ID:
      return {
        ...state,
        qcId: payload
      };
    case actionTypes.SET_QTY:
      return {
        ...state,
        qty: payload
      };
    case actionTypes.SET_CAPACITY_PIPE:
      return {
        ...state,
        capacityPipe: payload
      };
    case actionTypes.SET_CAPACITY_AVAILABLE:
      return {
        ...state,
        capacityAvailable: payload
      };
    case actionTypes.SET_ATTRIBS_INHERIT:
      return {
        ...state,
        plantOperationAttribsInheritDtos: payload
      };
    case actionTypes.SET_THICKNESS:
      return {
        ...state,
        thickness: payload
      };
    case actionTypes.SET_SAVED_QUANTITY:
      return {
        ...state,
        quantity: payload
      };
    case actionTypes.SET_SAVED_QUANTITY_OFF:
      return {
        ...state,
        quantityOff: payload
      };
    case actionTypes.SET_UNIT:
      return {
        ...state,
        productUnit: payload
      };
    case actionTypes.GET_READY_BY_SEMI:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.GET_READY_BY_SEMI_FAIL:
      return {
        ...state,
        okRequest: false,
        loading: false
      };
    case actionTypes.GET_READY_BY_SEMI_SUCCESS:
      return {
        ...state,
        readyProductsBySemi: payload,
        okRequest: true,
        loading: false,
        error: false
      };

    case actionTypes.GET_ZDVL_BY_TASK:
      return {
        ...state,
        zdvlByTask: [],
        zdvlLineNumIdsByTask: [],
        zdvlByTaskGet: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.GET_ZDVL_BY_TASK_SUCCESS:
      return {
        ...state,
        zdvlByTask: payload,
        zdvlLineNumIdsByTask: Array.from(new Set(payload.map((el) => el.zdvlLineNumId))),
        zdvlByTaskGet: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.GET_ZDVL_BY_TASK_FAIL:
      return {
        ...state,
        zdvlByTask: [],
        zdvlLineNumIdsByTask: [],
        zdvlByTaskGet: {
          okRequest: false,
          loading: false
        }
      };
    case actionTypes.SET_SAVE_REQUEST:
      return {
        ...state,
        okSaveRequest: payload
      }
    default:
      return state;
  }
};

export default reducer;
